<div class="flex items-center justify-center w-full md:p-4">
    <span>Cancelado. Obrigado :)</span>
</div>
